import React from 'react';
import {TitleWithTooltip} from './TicketSelect/TicketSelectionPopover';

function TicketsRegistrationPopover({children, onDone}) {
    return (<div className="tickets-registration-popup">
        <div>
            <div className="tickets-registration-popup__title"><TitleWithTooltip id="tickets-registration-popover-title"/></div>
        </div>
        <div className="tickets-registration-popup__body">
            {children}
        </div>
        <div className="tickets-registration-popup__footer padding-top-small padding-right-small padding-bottom-small">
            <button onClick={onDone}
                className='tickets-registration-popup__button color-1-background color-1-border custom-color'>
                Done
            </button>
        </div>
    </div>);
}

export default TicketsRegistrationPopover;
